$.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null) {
     return null;
  }
  return decodeURI(results[1]) || 0;
}

var baseDomain = 'https://store.sony.co.th';
var apiToken = getCookie('api_token');

var serverlessHttp = {
  baseUrl: [baseDomain, 'apps/api'].join('/'),
  sendReq: function(url, method, content, datakey) {
    var reqOpt = {
        type: method,
          url: [this.baseUrl, url].join('/'),
          headers: {
            'x-api-key': apiToken,
            'issuer': '1644167203',
            'datakey': datakey
          },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
    };

    if (method.toLowerCase() !== 'get')
        reqOpt['data'] = JSON.stringify(content);

    var def = $.Deferred();
    $.ajax(reqOpt).done(function (res) {
        def.resolve(res);
    }).fail(function (ex) {
        def.resolve(ex);
        console.log(ex);
    });

    return def.promise();
  },
  get: function (url, datakey) {
      return this.sendReq(url, 'get', datakey);
  },
  post: function (url, content, datakey) {
      return this.sendReq(url, 'post', content, datakey);
  },
  put: function (url, content, datakey) {
      return this.sendReq(url, 'put', content, datakey);
  },
  delete: function (url, content, datakey) {
      return this.sendReq(url, 'delete', content, datakey);
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, expirationInSecond) {
  const d = new Date()
  
  d.setTime(expirationInSecond * 1000);

  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Get API Token
async function getAPIToken() {
  if (!apiToken) {
    try {
      const response = await $.ajax({
        method: 'GET',
        url: `${baseDomain}/apps/api/authen/api-token`,
        headers: {
          'issuer': '1644167203',
          'Accept-Language': 'en-US'
        },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
      });

      apiToken = response.token;
      setCookie('api_token', apiToken, response.expired - 600);
      return apiToken;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

async function callAPIWithTokenRefresh (url, method, content, datakey) {
  try {
    if (!getCookie('api_token')) {
      await getAPIToken();
    }
    const response = await serverlessHttp.sendReq(url, method, content, datakey);
    return response;
  } catch (ex) {
    if (ex.status === 401) {
      // Token expired, refresh the token
      try {
        await getAPIToken();
        // Retry the API call with the new token
        return await serverlessHttp.sendReq(url, method, content, datakey);
      } catch (err) {
        console.log(err);
        throw err; // Token refresh failed
      }
    } else {
      throw ex; // Other API call failure
    }
  }
}

getAPIToken();
